import EdoBilling from './EdoBilling';

export default EdoBilling;
